export default {
      id: "no-orders-steps-usage",
      viewBox: "0 0 275 198",
      url: __webpack_public_path__ + "svgsprite.svg#no-orders-steps",
      toString: function () {
        return this.url;
      }
    }